/* Maison Felzo : avis clients (modale, etoiles, envoi, filtres, depot) */
(function () {
  var CFG = window.MF_AVIS || {}
  function qs(sel, root) { return (root || document).querySelector(sel) }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)) }
  var LABELS = { 1: 'Décevant', 2: 'Moyen', 3: 'Correct', 4: 'Très bien', 5: 'Excellent' }

  /* ---------- Etoiles : texte de la note choisie, compteur ---------- */
  qsa('[data-avis-form]').forEach(function (form) {
    var txt = qs('[data-avis-ratetxt]', form)
    qsa('input[name=rating]', form).forEach(function (r) {
      r.addEventListener('change', function () { if (txt) txt.textContent = r.value + ' sur 5 : ' + LABELS[r.value] })
    })
    var body = qs('textarea[name=body]', form), cnt = qs('[data-avis-count]', form)
    if (body && cnt) body.addEventListener('input', function () { cnt.textContent = body.value.length + ' / 2000' })
  })

  /* ---------- Modale ---------- */
  var lastFocus = null
  function focusables(box) {
    return qsa('a[href],button:not([disabled]),input:not([disabled]):not([tabindex="-1"]),textarea,select', box).filter(function (el) { return el.offsetParent !== null })
  }
  function openModal(m) {
    lastFocus = document.activeElement
    m.hidden = false
    m.classList.add('is-open')
    document.documentElement.classList.add('avm-lock')
    var first = qs('.avf__stars input', m) || qs('input,textarea', m)
    var box = qs('.avm__box', m)
    setTimeout(function () { (first || box).focus() }, 30)
  }
  function closeModal(m) {
    m.classList.remove('is-open')
    m.hidden = true
    document.documentElement.classList.remove('avm-lock')
    if (lastFocus && lastFocus.focus) lastFocus.focus()
  }
  qsa('[data-avis-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      var m = document.getElementById(b.getAttribute('data-avis-open'))
      if (m) openModal(m)
    })
  })
  qsa('.avm').forEach(function (m) {
    qsa('[data-avis-close]', m).forEach(function (b) { b.addEventListener('click', function () { closeModal(m) }) })
    m.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); closeModal(m); return }
      if (e.key !== 'Tab') return
      var list = focusables(qs('.avm__box', m))
      if (!list.length) return
      var a = list[0], z = list[list.length - 1]
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus() }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus() }
    })
  })

  /* ---------- Envoi du formulaire ---------- */
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  function val(form, name) { var el = form.elements[name]; return el ? String(el.value || '').trim() : '' }
  function showErr(form, msg) {
    var e = qs('[data-avis-err]', form)
    if (!e) return
    e.textContent = msg || ''
    e.hidden = !msg
    if (msg) e.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
  }
  function success(form, d) {
    var wrap = form.parentNode
    var ok = qs('[data-avis-ok]', wrap)
    var msg = d.message
    if (!msg) {
      msg = d.status === 'approved'
        ? 'Votre avis est publié. Merci d’avoir pris le temps de l’écrire.'
        : 'Votre avis a bien été reçu. Il sera publié après modération par notre équipe, en général sous quelques jours.'
    }
    qs('[data-avis-ok-text]', ok).textContent = msg
    form.hidden = true
    ok.hidden = false
    var t = qs('[data-avis-ok-title]', ok)
    if (t) { t.setAttribute('tabindex', '-1'); t.focus() }
    var hello = qs('[data-avis-hello]')
    if (hello) hello.hidden = true
  }
  function submitForm(form) {
    if (form.__busy) return
    if (!CFG.api) return showErr(form, 'Le dépôt d’avis est momentanément indisponible.')
    var picked = qs('input[name=rating]:checked', form)
    var rating = picked ? parseInt(picked.value, 10) : 0
    var name = val(form, 'name'), mail = val(form, 'email'), title = val(form, 'title'), body = val(form, 'body')
    var consent = !!(form.elements.consent && form.elements.consent.checked)
    if (!(rating >= 1 && rating <= 5)) return showErr(form, 'Choisissez une note de 1 à 5 étoiles.')
    if (!name) return showErr(form, 'Indiquez votre prénom et votre nom.')
    if (!val(form, 'token') && !val(form, 'order_name')) return showErr(form, 'Indiquez votre numéro de commande : les avis sont réservés aux acheteurs.')
    if (!EMAIL.test(mail)) return showErr(form, 'Adresse e-mail invalide.')
    if (title.length > 80) return showErr(form, 'Le titre ne doit pas dépasser 80 caractères.')
    if (body.length < 20) return showErr(form, 'Votre avis doit contenir au moins 20 caractères.')
    if (body.length > 2000) return showErr(form, 'Votre avis ne doit pas dépasser 2000 caractères.')
    if (/https?:\/\/|www\./i.test(body + ' ' + title)) return showErr(form, 'Les liens ne sont pas acceptés dans un avis.')
    if (!consent) return showErr(form, 'Cochez la case de consentement pour envoyer votre avis.')
    showErr(form, '')
    var payload = {
      product_id: val(form, 'product_id'), product_handle: val(form, 'product_handle'), product_title: val(form, 'product_title'),
      product_url: val(form, 'product_url'), sku: val(form, 'sku'),
      name: name, email: mail, rating: rating, title: title, body: body, consent: true,
      token: val(form, 'token'), order_name: val(form, 'order_name'), hp: val(form, 'hp'),
      page_url: location.origin + location.pathname
    }
    var btn = qs('[data-avis-send]', form), label = btn.textContent
    form.__busy = true
    btn.disabled = true
    btn.textContent = 'Envoi en cours...'
    fetch(CFG.api + '?action=avis_public_submit', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json() })
      .then(function (d) {
        if (d && d.ok) { success(form, d); return }
        showErr(form, (d && d.error) || 'Une erreur est survenue, merci de réessayer.')
      })
      .catch(function () { showErr(form, 'Connexion impossible pour le moment. Réessayez dans un instant ou écrivez-nous par e-mail.') })
      .then(function () { form.__busy = false; btn.disabled = false; btn.textContent = label })
  }
  qsa('[data-avis-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); submitForm(form) })
  })

  /* ---------- Fiche produit : voir plus d'avis ---------- */
  qsa('[data-avis-showmore]').forEach(function (b) {
    b.addEventListener('click', function () {
      var sec = b.closest('.avp')
      qsa('.avc[hidden]', sec).forEach(function (c) { c.hidden = false })
      b.parentNode.hidden = true
    })
  })

  /* ---------- Page Avis : filtres, tri, charger plus ---------- */
  var page = qs('[data-avis-page]')
  var list = page ? qs('[data-avis-list-page]', page) : null
  if (page && list) {
    var cards = qsa('.avc', list)
    var step = parseInt(page.getAttribute('data-visible'), 10) || 6
    var state = { rating: 0, sort: 'recent', shown: step }
    var more = qs('[data-avis-more]', page), empty = qs('[data-avis-empty]', page), status = qs('[data-avis-status]', page)
    var filters = qsa('[data-avis-filter]', page)
    var sortSel = qs('[data-avis-sort]', page)
    cards.forEach(function (c, i) { c.__i = i })
    var dateOf = function (c) { return String(c.getAttribute('data-date')) }
    var rateOf = function (c) { return +c.getAttribute('data-rating') }
    var sorters = {
      recent: function (a, b) { return dateOf(b).localeCompare(dateOf(a)) || a.__i - b.__i },
      old: function (a, b) { return dateOf(a).localeCompare(dateOf(b)) || a.__i - b.__i },
      high: function (a, b) { return rateOf(b) - rateOf(a) || a.__i - b.__i },
      low: function (a, b) { return rateOf(a) - rateOf(b) || a.__i - b.__i }
    }
    var render = function () {
      var match = cards.filter(function (c) { return !state.rating || rateOf(c) === state.rating })
      match.sort(sorters[state.sort])
      cards.forEach(function (c) { c.hidden = true })
      match.forEach(function (c, i) { list.appendChild(c); c.hidden = i >= state.shown })
      if (more) more.hidden = match.length <= state.shown
      if (empty) empty.hidden = match.length > 0
      if (status) status.textContent = match.length ? (Math.min(match.length, state.shown) + ' avis affichés sur ' + match.length) : ''
      filters.forEach(function (f) {
        var on = +f.getAttribute('data-avis-filter') === state.rating
        f.setAttribute('aria-pressed', on ? 'true' : 'false')
        if (f.classList.contains('avpage__chip')) f.classList.toggle('is-on', on)
      })
    }
    filters.forEach(function (f) {
      f.addEventListener('click', function () {
        var v = +f.getAttribute('data-avis-filter')
        state.rating = (state.rating === v) ? 0 : v
        state.shown = step
        render()
      })
    })
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; state.shown = step; render() })
    if (more) more.addEventListener('click', function () { state.shown += step; render() })
    render()
  }

  /* ---------- Accueil : carrousel d'avis ---------- */
  qsa('[data-avis-carousel]').forEach(function (sec) {
    var track = qs('[data-avis-track]', sec), prev = qs('[data-avis-prev]', sec), next = qs('[data-avis-next]', sec)
    if (!track) return
    var by = function (dir) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      track.scrollBy({ left: dir * Math.max(280, track.clientWidth * 0.8), behavior: reduce ? 'auto' : 'smooth' })
    }
    var upd = function () {
      var max = track.scrollWidth - track.clientWidth - 2
      if (prev) prev.disabled = track.scrollLeft <= 2
      if (next) next.disabled = track.scrollLeft >= max
    }
    if (prev) prev.addEventListener('click', function () { by(-1) })
    if (next) next.addEventListener('click', function () { by(1) })
    track.addEventListener('scroll', function () { window.requestAnimationFrame(upd) }, { passive: true })
    window.addEventListener('resize', upd)
    upd()
  })

  /* ---------- Page « Laisser un avis » ---------- */
  var dep = qs('[data-avis-deposit]')
  if (dep) {
    var stateEl = qs('[data-avis-state]', dep), pieceBox = qs('[data-avis-piece]', dep), formBox = qs('[data-avis-formbox]', dep)
    var endBox = qs('[data-avis-end]', dep), dform = qs('[data-avis-form]', dep)
    var token = (new URLSearchParams(location.search).get('avis') || '').trim()
    // Étiquette surprise : le paramètre s (code court de l'étiquette) affiche la mention de transparence et un lien de retour vers le bon (révélé par le logiciel une fois l'avis enregistré)
    var sCode = (new URLSearchParams(location.search).get('s') || '').trim()
    if (/^[a-z2-9]{7}$/.test(sCode)) {
      var rw = qs('[data-avis-reward]', dep)
      if (rw) rw.hidden = false
      var sl = qs('[data-avis-surprise]', dep)
      if (sl && CFG.api) { sl.href = CFG.api.replace(/api.php.*$/, 'r.php') + '?c=' + sCode; sl.hidden = false }
    }
    var end = function (msg) {
      stateEl.hidden = true
      formBox.hidden = true
      endBox.hidden = false
      qs('[data-avis-end-text]', endBox).textContent = msg
    }
    if (!CFG.api) {
      end('Le dépôt d’avis est momentanément indisponible.')
    } else if (!token) {
      var note = qs('[data-avis-notoken]', dep)
      if (note) note.hidden = false
      stateEl.hidden = true
      formBox.hidden = false
    } else {
      fetch(CFG.api + '?action=avis_public_invite&token=' + encodeURIComponent(token))
        .then(function (r) { return r.json() })
        .then(function (d) {
          if (!d || !d.ok) { end((d && d.error) || 'Lien invalide ou expiré.'); return }
          var p = d.product || {}
          if (p.title) {
            qs('[data-avis-piece-title]', dep).textContent = p.title
            var img = qs('[data-avis-piece-img]', dep)
            if (p.image) { img.src = p.image; img.hidden = false }
            pieceBox.hidden = false
          }
          if (d.already_reviewed) { end('Vous avez déjà donné votre avis sur cette pièce. Merci, nous l’avons bien reçu.'); return }
          var set = function (n, v) { if (dform.elements[n]) dform.elements[n].value = v || '' }
          set('product_id', p.id)
          set('product_handle', p.handle)
          set('product_title', p.title)
          set('product_url', p.url)
          set('sku', p.sku)
          set('token', token)
          var ob = qs('[data-avis-orderbox]', dform)
          if (ob) { ob.hidden = true; if (dform.elements.order_name) dform.elements.order_name.required = false }
          if (d.name) { set('name', d.name + ' '); dform.elements.name.dispatchEvent(new Event('input')) }
          var hello = qs('[data-avis-hello]', dep)
          if (hello) hello.textContent = d.name ? ('Bonjour ' + d.name + ', votre avis') : 'Votre avis'
          stateEl.hidden = true
          formBox.hidden = false
        })
        .catch(function () { end('Connexion impossible pour le moment. Réessayez dans un instant.') })
    }
  }
})()
